import React from "react";
import { useNavigate } from "react-router-dom";

const AiCard = ({ image, title, desc, time, chatId, conversation, name }) => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => {
        navigate("/ai/chat", {
          state: { image, title, desc, time, chatId, conversation, name },
        });
      }}
      className="w-100 d-flex position-relative align-items-center mb-2"
      style={{
        cursor: "pointer",
        borderRadius: "5px",
        padding: "10px 10px",
        border: "1px solid #989898",
      }}
    >
      <div style={{ height: "50px" }}>
        <img src={image} alt="ai-bot" style={{ height: "100%" }} />
      </div>
      <div className="d-flex flex-column" style={{ padding: "2px 10px" }}>
        <p className="fs18 fw-bold" style={{ marginBottom: "2px" }}>
          {name ? name : title}
        </p>
        <p
          className={`m-0 ${name ? "mb-1" : "mb-0 desc-ai-text-container"}`}
          style={{
            fontSize: "10px",
            fontWeight: name ? 600 : 650,
            lineHeight: "13px",
          }}
        >
          {name ? title : desc}
        </p>
        {name && conversation.length > 0 && (
          <p
            className="m-0 conversation-text-container"
            style={{
              fontSize: "10px",
              fontWeight: 650,
              lineHeight: "13px",
            }}
          >
            {conversation[conversation.length - 1].text}
          </p>
        )}
      </div>
      {time && (
        <p
          className="position-absolute "
          style={{
            fontSize: "10px",
            fontWeight: 600,
            top: "10px",
            right: "10px",
          }}
        >
          {time}
        </p>
      )}
    </div>
  );
};

export default AiCard;
